import React from "react";
import s from "../checklists.less";
import { useTranslation } from "react-i18next";

interface IProps {
  actualPoints: number;
  maxPoints: number;
  result: number;
  id: string;
}
const ChecklistHeader: React.FC<IProps> = ({
  actualPoints,
  maxPoints,
  result,
  id,
}) => {
  const { t } = useTranslation();
  return (
    <div className={s.mainHeader}>
      <div>
        <div className={s.headerTitle}>
          {t(`pkd_checklists.table.actualPoints`)}
        </div>
        <div className={s.headerData}>{actualPoints}</div>
      </div>
      <div>
        <div className={s.headerTitle}>
          {t(`pkd_checklists.table.maxPoints`)}
        </div>
        <div className={s.headerData}>{maxPoints}</div>
      </div>
      <div>
        <div className={s.headerTitle}>{t(`pkd_checklists.table.result`)}</div>
        <div className={s.headerData}>{result}</div>
      </div>
      <div>
        <a
          className={s.headerData}
          href={`https://vaz.autocrm.ru/check-list/survey/view?id=${id}`}
        >
          DNM
        </a>
      </div>
    </div>
  );
};

export default ChecklistHeader;
